import React from 'react'
import AuthComponent from '../../components/auth-component/AuthComponent'

function Auth() {
  return (
    <div><AuthComponent/></div>
  )
}

export default Auth